import React from "react";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Grid, Paper } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { connect } from "react-redux";

import { SET_PERMISSIONS } from "../store/actions.ts";
import ConditionsSet from "./ConditionsSet";
import { useDialog } from "../licensing/utils/DialogProvider";
import { _post } from "../http";

import { loadPermissions, useProductionSettings } from "../store/reducers/permissions.jsx";

const useStyles = makeStyles()((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    width: "100%",
    marginBottom: 20,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  section: {
    // border: "orange 2px solid",
    position: "relative",
  },
  tagList: { display: "flex", margin: 0, padding: 0, flexFlow: "row wrap" },
  tag: {
    fontWeight: 800,
    borderRadius: 5,
    margin: "0 5px",
    listStyleType: "none",
  },
  label: { fontSize: "0.6rem" },
  selectPermissionContainer: { display: "flex", flexDirection: "row", margin: 0, marginBottom: 10 },
  rootIcon: { display: "inline", position: "absolute", right: 5, top: 5 },
}));

const permissionTypes = ["write", "read"];

function PermissionEditorDialog(props) {
  const { classes } = useStyles();
  const [, closeDialog] = useDialog();

  const permissionKey = props.permissionKey;
  const permissions = props.permissions;
  const [permission, setPermission] = React.useState(
    permissions[permissionKey] ? JSON.parse(JSON.stringify(permissions[permissionKey])) : { write: [] }
  );

  const savePermission = () => {
    let postUrl = "core/backofficePermission";
    if (permission.id) {
      postUrl += "/" + permission.id;
    }
    _post(postUrl, { value: permission, permission_key: permissionKey, applied: false }).then((response) => {
      // setPermission(response.data.data.value);
      const appliedPermissions = { fake: true };
      props.setPermissions({ ...props.permissions, [permissionKey]: permission }, appliedPermissions);
      closeDialog();
    });
  };

  return (
    <>
      <DialogTitle id={"form-dialog-title"}>Permissions Editor</DialogTitle>
      <DialogContent>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            color={"primary"}
            disabled={Object.keys(props.toBeAppliedPermissions).length === 0}
            onClick={() => {
              _post("core/backofficePermission/generatePermissionsFile", {
                useProductionSettings: useProductionSettings,
              }).then(() => {
                loadPermissions();
              });
            }}
            variant={"contained"}
          >
            Deploy Permissions
          </Button>
          <Button
            color={"primary"}
            variant={"contained"}
            onClick={() => {
              if (useProductionSettings) {
                localStorage.removeItem("permissionsUseProductionSettings");
                localStorage.removeItem("backoffice_permissions");
              } else {
                localStorage.setItem("permissionsUseProductionSettings", "true");
                localStorage.removeItem("backoffice_permissions");
              }
              location.reload();
            }}
            // style={{ fontWeight: useProductionSettings ? 800 : null }}
          >
            {useProductionSettings ? "Use local config" : "Use production config"}
          </Button>
        </div>
        <div className={classes.root}>
          <Grid container>
            <Grid className={classes.section} item sm={12}>
              <b>Selected Permission:</b> {props.permissionKey}
            </Grid>
            {permissionTypes.map((type) => {
              return (
                <Grid component={Paper} container key={type} sm={12} xs={12}>
                  <Grid item xs={12}>
                    {type.toUpperCase()}
                    {": "}
                    <Button
                      onClick={() => {
                        const defaultConditionType = sessionStorage.getItem("defaultConditionType") ?? "SOLUTION";
                        let defaultConditionValue = sessionStorage.getItem("defaultConditionValue") ?? "QR";
                        if (defaultConditionType === "OR") {
                          defaultConditionValue = [];
                        }

                        if (!permission[type]) {
                          permission[type] = [];
                        }

                        permission[type].push({
                          type: defaultConditionType,
                          value: defaultConditionValue,
                        });

                        setPermission({ ...permission });
                      }}
                      size={"small"}
                      variant={"outlined"}
                    >
                      Add condition set
                    </Button>
                  </Grid>

                  <Grid item xs={12}>
                    {permission != undefined && permission[type] ? (
                      <ConditionsSet
                        conditions={permission[type]}
                        onDeleteSet={() => {
                          delete permission[type];
                          setPermission({ ...permission });
                        }}
                        setIndex={0}
                        setPermissions={() => {
                          setPermission({ ...permission });
                        }}
                      />
                    ) : null}
                  </Grid>
                </Grid>
              );
            })}
          </Grid>
        </div>
      </DialogContent>
      <DialogActions>
        <Button classes={{ label: classes.label }} color={"primary"} onClick={() => savePermission()}>
          Save Permission
        </Button>
      </DialogActions>
    </>
  );
}

export default connect(
  (state) => ({
    permissions: state.permissions.permissions,
    toBeAppliedPermissions: state.permissions.toBeAppliedPermissions,
  }),
  (dispatch) => {
    return {
      setPermissions: (permissions, toBeAppliedPermissions) =>
        dispatch({
          type: SET_PERMISSIONS,
          permissions: { permissions },
          toBeAppliedPermissions: { ...toBeAppliedPermissions },
        }),
    };
  }
)(PermissionEditorDialog);
